import EmptyStateSystem from './EmptyStateSystem';
import './EmptyStateSystem.scss';

export default EmptyStateSystem;
